import classNames from 'classnames'
import React, { ReactNode, memo } from 'react'

type Props = {
  children: ReactNode
  className?: string
}

export const TableContainer = memo(({ className, children }: Props) => <div className={classNames(className, 'rounded-lg w-full')}>{children}</div>)
